<template>
  <div>
    <section class="text-center col-12 col-lg-10 col-xl-8 mx-auto p-4">
      <b-row class="col-12 text-center mb-4">
        <b-col class="mx-auto col-6 col-md-4 col-lg-3">
          <b-img
            :src="require(`@/assets/puntofarma/logo.svg`)"
            fluid
            :alt="$t('FeverPrivacy.logo_alt')"
          ></b-img>
        </b-col>
      </b-row>

      <h1 class="h3 mb-4">{{ $t('FeverPrivacy.titolo') }}</h1>

      <div class="privacy-content-container mb-4">
        <iframe
          :src="htmlUrl"
          :title="$t('FeverPrivacy.pdf_title')"
          class="privacy-iframe"
          :aria-label="$t('FeverPrivacy.pdf_aria_label')"
        ></iframe>
      </div>

      <b-row class="justify-content-center">
        <b-col cols="auto">
          <b-button
            variant="secondary"
            @click="tornaIndietro"
            :aria-label="$t('FeverPrivacy.indietro_aria_label')"
          >
            {{ $t('indietro') }}
          </b-button>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
export default {
  name: "FeverPrivacy",
  data() {
    return {
      htmlUrl: "/fever/privacy-policy.html",
    };
  },
  methods: {
    tornaIndietro() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.privacy-content-container {
  position: relative;
  width: 100%;
  height: 75vh;
}

.privacy-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 768px) {
  .privacy-content-container {
    height: 60vh;
  }
}
</style>
